import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type TFormCardProps = {
    className?: string;
    children: ReactNode;
};

export const FormCard = ({ className, children }: TFormCardProps) => (
    <div
        className={twMerge(
            'mx-auto h-max w-full max-w-[900px] rounded-2xl bg-white px-[35px] py-[41px] shadow-lightCard dark:bg-dark-3 dark:shadow-darkCard md:px-[60px] md:py-[68px] lg:px-[110px] lg:py-[58px]',
            className
        )}
    >
        {children}
    </div>
);
